// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__uYZt0","title":"Info_title__2qv3M","links":"Info_links__3wq2b","link":"Info_link__1KKbo","logo":"Info_logo__2p-1Q"};